import { motion } from "framer-motion";
import { Star, ShieldCheck, Clock, ThumbsUp, Award } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Assurance décennale", highlight: false },
  { icon: Clock, label: "Devis sous 24h", highlight: true },
  { icon: ThumbsUp, label: "+200 chantiers", highlight: false },
  { icon: Award, label: "Artisan local Sens", highlight: false },
];

const TrustBanner = () => (
  <section className="bg-secondary border-y border-border overflow-hidden">
    <div className="container-custom px-4 py-4 md:py-5">
      <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
        {items.map((item, i) => (
          <motion.div
            key={item.label}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.4 }}
            className="flex items-center gap-2"
          >
            <item.icon size={18} className={item.highlight ? "text-primary" : "text-secondary-foreground/70"} />
            <span className={`text-sm font-heading font-bold ${item.highlight ? "text-primary" : "text-secondary-foreground/90"}`}>
              {item.label}
            </span>
          </motion.div>
        ))}

        {/* Google Rating */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.4 }}
          className="flex items-center gap-2 bg-secondary-foreground/10 rounded-full px-4 py-1.5"
        >
          <div className="flex">
            {[1, 2, 3, 4, 5].map(i => (
              <Star key={i} size={14} className="text-primary fill-primary" />
            ))}
          </div>
          <span className="font-heading font-bold text-secondary-foreground text-sm">5/5</span>
          <span className="text-secondary-foreground/60 text-xs">Google</span>
        </motion.div>
      </div>
    </div>
  </section>
);

export default TrustBanner;
